import UrlGeneration from '../urlGeneration';
import EstateLister from '../paginator/estate.js';

function runSearch(input) {
  UrlGeneration.init();
  var search = input.value;
  if (search) {
    UrlGeneration.set('search', search);
  } else {
    UrlGeneration.remove('search');
  }
  UrlGeneration.update();
  const obEstateLister = new EstateLister();
  obEstateLister.setReplaceMode(true);
  obEstateLister.init(true);
}

let timer;
function goSearch(event) {
  clearTimeout(timer);

  timer = setTimeout(() => {
    runSearch(this);
  }, 400);
}

function init() {
  const searcherInput = document.querySelector(`[data-nika-estate-searcher]`);
  if (searcherInput) {
    searcherInput.addEventListener('input', goSearch, false);
  }
}

init();
